import { Box, Button, Card, Grid, IconButton, ListItem, Toolbar, Paper, InputBase, CircularProgress, Typography, Tooltip, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import { ArrowBackIos, CheckCircleOutline, Search } from '@mui/icons-material'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { dateWithTime, useStylesTheme } from '../../config'
import { notificationsRoutes } from '../../routes'
import { useNotificationsContext } from '../../context/Notifications.context'
import { useUsersContext } from '../../context/Users.context'
import { useStatus } from '../../context/Status.context'
import { useSitesContext } from '../../context/Sites.context'
import { LoadingLogoDialog, UserListDataDialog } from '../../dialogs'

const NotificationsPage = () => {
    const { myNotifications, getNotifications, markNotificationAsRead, resolveNotification } = useNotificationsContext()
    const { usersMap } = useUsersContext()
    const { sites } = useSitesContext()
    const { setstatus } = useStatus()
    const [openLoading, setOpenLoading] = useState(false)
    const [notificationsList, setNotificationList] = useState([])
    const [notificationsListCache, setNotificationListCache] = useState([])
    const [notificationsListCacheBusqueda, setNotificationListCacheBusqueda] = useState([])
    const [totalItems, setTotalItems] = useState(20)
    const [openLogo, setOpenLogo] = useState(false)
    const [height, setHeight] = useState(0)
    const navigate = useNavigate()
    const divRef = useRef()
    const [openUserDialog, setOpenUserDialog] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedNotificationId, setSelectedNotificationId] = useState(null)
    const [confirmResolve, setConfirmResolve] = useState({ open: false, id: null })

    const getSiteName = (siteId) => {
        if (!siteId) return null
        const id = typeof siteId === 'object' ? siteId._id : siteId
        const found = sites.find(s => s._id === id)
        return found ? `${found.idObra} - ${found.descripcion}` : (typeof siteId === 'object' ? (siteId.name || 'Sitio no especificado') : siteId)
    }

    const handleScroll = (e) => {
        const scrolledFromTop = divRef.current.scrollTop
        if (scrolledFromTop > (height - 100)) {
            const newTotal = totalItems + 20
            setTotalItems(newTotal)
        }
    }

    useEffect(() => {
        setNotificationList((notificationsListCacheBusqueda.length > 0) ? notificationsListCacheBusqueda.slice(0, totalItems) : /* notificationsListCache */myNotifications.slice(0, totalItems))
    }, [totalItems])

    useEffect(() => {
        const el = document.getElementById('notification-container')
        if (el) {
            setHeight(el.scrollHeight - el.offsetHeight)
        }
    }, [notificationsList])

    useEffect(() => {
        if (myNotifications.length > 0) {
            setNotificationList(myNotifications.slice(0, totalItems))
            setNotificationListCache(myNotifications.slice(0, 1000))
            const el = document.getElementById('notification-container')
            if (el) {
                setHeight(el.scrollHeight - el.offsetHeight)
            }
        }
    }, [myNotifications])

    const handleAction = async (item) => {
        if (item.type === 'PASSWORD_RESET') {
            const userId = item.metadata?.userId
            if (userId && usersMap[userId]) {
                setSelectedUser(usersMap[userId])
                setSelectedNotificationId(item._id)
                setOpenUserDialog(true)
                markNotificationAsRead(item._id)
            } else {
                setstatus({
                    status: 'error',
                    title: 'Error',
                    message: 'No se pudo encontrar la información del usuario.'
                })
            }
        } else if (item.url) {
            navigate(item.url)
            markNotificationAsRead(item._id)
        }
    }

    const handleResolve = async (id) => {
        setConfirmResolve({ open: true, id })
    }

    const confirmResolveAction = async () => {
        const id = confirmResolve.id
        setConfirmResolve({ open: false, id: null })
        setOpenLoading(true)
        try {
            await resolveNotification(id)
            setstatus({
                status: 'completed',
                severity: 'success',
                title: 'Éxito',
                message: 'Notificación marcada como realizada.'
            })
        } catch (error) {
            setstatus({
                status: 'error',
                title: 'Error',
                message: 'No se pudo actualizar el estado de la notificación.'
            })
        } finally {
            setOpenLoading(false)
        }
    }

    const todoLeido = () => {
        setOpenLoading(true)
        setTimeout(() => {
            const notifications = [...myNotifications]
            notifications.forEach((not, index) => {
                markNotificationAsRead(not._id)
                if (index === (notifications.length - 1)) {
                    getNotifications()
                    setOpenLoading(false)
                }
            })
        }, 1000)
    }

    const buscar = (value) => {
        setOpenLogo(true)
        if (value.length > 2) {
            const newNotificationList = []
            notificationsListCache.forEach((not, i) => {
                const siteName = getSiteName(not.siteId) || ''
                if (
                    not.title.toLowerCase().includes(value.toLowerCase()) ||
                    (not.subtitle && not.subtitle.toLowerCase().includes(value.toLowerCase())) ||
                    not.message.toLowerCase().includes(value.toLowerCase()) ||
                    siteName.toLowerCase().includes(value.toLowerCase())
                ) {
                    newNotificationList.push(not)
                }
            })
            setNotificationList(newNotificationList.slice(0, totalItems))
            setNotificationListCacheBusqueda(newNotificationList)
        } else {
            setNotificationList(notificationsListCache)
            setNotificationListCacheBusqueda([])
            setTotalItems(20)
        }
        setOpenLogo(false)
    }

    return (
        <Box height='100%'>
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={'pageCard'}>
                        <Grid container alignItems='center' justifyContent='center'>
                            <div style={{ width: '100%', textAlign: 'left', padding: 10 }}>
                                <div style={{ width: '100%', textAlign: 'left', color: '#333', backgroundColor: '#fff', borderRadius: 20 }}>
                                    <Toolbar style={{ paddingLeft: 0, backgroundColor: '#F9F9F9', borderRadius: 10, display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <IconButton onClick={() => setTimeout(() => {
                                                navigate(-1)
                                            }, 500)}>
                                                <ArrowBackIos style={{ color: '#333', fontSize: 16 }}/>
                                            </IconButton>
                                            <h1 style={{ marginTop: 0, marginBottom: 0, fontSize: 16 }}>
                                                Notificaciones
                                            </h1>
                                        </div>
                                        <Paper
                                            component="form"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: { xs: 200, sm: 400 }, mr: 1 }}
                                        >
                                            <IconButton sx={{ p: '10px' }} aria-label="menu">
                                                <Search />
                                            </IconButton>
                                            <InputBase
                                                onChange={(e) => { buscar(e.target.value) }}
                                                sx={{ ml: 1, flex: 1 }}
                                                placeholder="Buscar en notificaciones"
                                                inputProps={{ 'aria-label': 'buscar en notificaciones' }}
                                            />
                                        </Paper>
                                    </Toolbar>
                                </div>
                            </div>
                        </Grid>
                        <Grid alignItems='center' justifyContent='center' style={{ padding: 10, borderRadius: 20 }}>
                            <div >
                                <ListItem style={{ backgroundColor: '#F9F9F9', padding: '10px 16px' }}>
                                    <div style={{ width: '5%', fontSize: 12 }}>
                                        <p style={{ margin: 0, fontSize: 16, fontWeight: 'bold' }}>N°</p>
                                    </div>
                                    <div style={{ width: '25%', marginLeft: 5, fontSize: 12 }}>
                                        <p style={{ margin: 0, fontSize: 16, fontWeight: 'bold' }}>Título</p>
                                    </div>
                                    <div style={{ width: '40%', marginLeft: 5, fontSize: 12 }}>
                                        <p style={{ fontSize: 16, fontWeight: 'bold', margin: 0 }}>Mensaje</p>
                                    </div>
                                    <div style={{ width: '20%', marginLeft: 5, fontSize: 12 }}>
                                        <p style={{ fontSize: 16, fontWeight: 'bold', margin: 0 }}>Información</p>
                                    </div>
                                    <div style={{ width: '10%', marginLeft: 5, fontSize: 12, textAlign: 'center' }}>
                                        <p style={{ fontSize: 16, fontWeight: 'bold', margin: 0 }}>
                                            Acción
                                        </p>
                                    </div>
                                </ListItem>
                            </div>
                            <div style={{ height: 'calc(100vh - 300px)', overflowY: 'auto' }} onScroll={handleScroll} ref={divRef} id='notification-container'>
                                {
                                    openLogo && <CircularProgress />
                                }
                                {
                                    !openLogo && notificationsList.map((item, index) => {
                                        const isPasswordReset = item.type === 'PASSWORD_RESET'

                                        return (
                                            <ListItem
                                                key={index}
                                                style={{
                                                    backgroundColor: item.isResolved ? '#e8f5e9' : (isPasswordReset ? '#fff9c4' : (item.state ? '#fff' : '#F9F9F9')),
                                                    borderLeft: item.isResolved ? '5px solid #4caf50' : (isPasswordReset ? '5px solid #fbc02d' : 'none'),
                                                    marginBottom: 2,
                                                    opacity: item.isResolved ? 0.8 : 1,
                                                    transition: 'all 0.3s ease',
                                                    padding: '10px 16px'
                                                }}
                                            >
                                                <div style={{ width: '5%', fontSize: 12 }}>
                                                    <h3 style={{ margin: 0 }}>{index + 1}</h3>
                                                </div>
                                                <div style={{ width: '25%', marginLeft: 5, fontSize: 12 }}>
                                                    <h3 style={{ margin: 0 }}>{item.title}</h3>
                                                    {item.subtitle && <h4 style={{ margin: 0 }}>{item.subtitle}</h4>}
                                                    {item.isResolved ? (
                                                        <Chip
                                                            size="small"
                                                            label="REALIZADO"
                                                            color="success"
                                                            sx={{ fontSize: 9, fontWeight: 800, mt: 0.5 }}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            size="small"
                                                            label="PENDIENTE"
                                                            color="warning"
                                                            sx={{ fontSize: 9, fontWeight: 800, mt: 0.5 }}
                                                        />
                                                    )}
                                                </div>
                                                <div style={{ width: '40%', marginLeft: 5, fontSize: 12 }}>
                                                    <p style={{ fontSize: 16, margin: 0 }}>{item.message}</p>
                                                    {item.isResolved && item.metadata?.userRevisor && (
                                                        <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 600, display: 'block', mt: 0.5 }}>
                                                            Resuelto por: {item.metadata.userRevisor.name} {item.metadata.userRevisor.lastName} el {dateWithTime(item.dateResolved)}
                                                        </Typography>
                                                    )}
                                                </div>
                                                <div style={{ width: '20%', marginLeft: 5, fontSize: 12 }}>
                                                    <Typography variant="caption" sx={{ display: 'block' }}>
                                                        <strong>Solicitante:</strong>
                                                    </Typography>
                                                    <p style={{ fontSize: 14, margin: 0 }}>
                                                        {item.metadata?.sender ? `${item.metadata.sender.name} ${item.metadata.sender.lastName}` : 'Sistema'}
                                                    </p>
                                                    {item.siteId && (
                                                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                                            <strong>Sitio:</strong> {getSiteName(item.siteId)}
                                                        </Typography>
                                                    )}
                                                    <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                                        <strong>Fecha:</strong> {dateWithTime(item.createdAt)}
                                                    </Typography>
                                                </div>
                                                <div style={{ width: '10%', marginLeft: 5, fontSize: 12, display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'center' }}>
                                                    {!item.isResolved ? (
                                                        <>
                                                            <Typography
                                                                style={{ cursor: 'pointer', color: 'brown', fontSize: 16, fontWeight: 'bold' }}
                                                                onClick={() => handleAction(item)}
                                                            >
                                                                Ir
                                                            </Typography>
                                                            {/* <Tooltip title="Marcar como realizado">
                                                                <IconButton size="small" onClick={() => handleResolve(item._id)}>
                                                                    <CheckCircleOutline color="success" />
                                                                </IconButton>
                                                            </Tooltip> */}
                                                        </>
                                                    ) : (
                                                        <CheckCircleOutline sx={{ color: '#4caf50' }} />
                                                    )}
                                                </div>
                                            </ListItem>
                                        )
                                    })
                                }
                            </div>
                            {
                                openLoading && <LoadingLogoDialog open={openLoading} />
                            }
                        </Grid>
                    </Card>
                </Grid>
            </Grid>

            {/* Dialogo de Confirmación */}
            {/* <Dialog
                open={confirmResolve.open}
                onClose={() => setConfirmResolve({ open: false, id: null })}
            >
                <DialogTitle>Confirmar Acción</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        ¿Estás seguro de marcar esta notificación como realizada?
                        Esta acción confirmará que la solicitud ha sido atendida.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmResolve({ open: false, id: null })} color="inherit">
                        Cancelar
                    </Button>
                    <Button onClick={confirmResolveAction} color="success" variant="contained" autoFocus>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog> */}

            {openUserDialog && selectedUser && (
                <UserListDataDialog
                    open={openUserDialog}
                    userModal={selectedUser}
                    closeModal={() => {
                        setOpenUserDialog(false)
                        setSelectedUser(null)
                    }}
                    notificationId={selectedNotificationId}
                    handleChange={() => {}}
                    checked={selectedUser.enabled}
                    setstatus={setstatus}
                />
            )}
        </Box>
    )
}

export default NotificationsPage
